import { render, staticRenderFns } from "./prepresslist.vue?vue&type=template&id=b24419d0&"
import script from "./prepresslist.vue?vue&type=script&lang=js&"
export * from "./prepresslist.vue?vue&type=script&lang=js&"
import style0 from "./prepresslist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports